
export function initPaddingTopSiteContent() {
    let scrollmenu = document.querySelector('.scrollmenu')
    let siteContent = document.querySelector('.site__content')
    if (scrollmenu && siteContent) {
        siteContent.style.paddingTop = `${scrollmenu.offsetHeight}px`;
    }
}